module.exports = __webpack_public_path__ + "img/drag.107d5f9a.svg";